<template>
  <div class="inputPassword">
    <label>パスワード</label>
    <input
      class="inputpasswordArea"
      v-model="password"
      placeholder="パスワードを入力"
      type="password"
      @focus="onFocus"
      @input="onInput"
    />
    <div v-show="isFocus">
      <p :class="{ clearValidation: checkCharacterNum }" class="checkItem">
        6文字以上
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-password",
  data() {
    return {
      password: "",
      isFocus: false,
    };
  },
  computed: {
    checkCharacterNum() {
      return this.password.length > 6;
    },
    checkAll() {
      return this.checkCharacterNum;
    },
  },
  methods: {
    onFocus() {
      this.isFocus = true;
    },
    onInput() {
      this.$emit("input", {
        value: this.password,
        check: this.checkAll,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.inputPassword {
  margin-bottom: 16px;

  label {
    display: block;
    margin-bottom: 4px;
  }
  input {
    font-size: 1rem;
    line-height: 2;
    width: calc(100% - 8px);
    border: none;
    border-bottom: 1px solid #373737;
  }
  .checkItem {
    color: #c0c0c0;

    &::before {
      content: "✔︎ ";
    }

    &.clearValidation {
      font-size: 0.8rem;
      color: #228b22;
    }
  }
  &.clearAll {
    .inputpasswordArea {
      border-color: #228b22;
      background: #98fb98;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputPassword.vue